import { useLazyQuery, useMutation } from "@apollo/client";
import { useAuthState } from "@/contexts/auth/auth.provider";
import {
  GET_PHONE_AS_STRING,
  GET_WHATSAPP_LINK,
} from "@/graphql/queries/get-phone";
import { INCREMENT_LISTING_ACTION } from "@/graphql/queries/listing";
import { Modal } from "@aqar-app/react-ui";
import LoginAlert, { WarningAlert } from "@/components/login-alert";

const useGetPhone = (listing) => {
  const { id } = listing || {};
  const token = useAuthState("token");
  const [incrementListingAction] = useMutation(INCREMENT_LISTING_ACTION);

  const handleError = (err) => {
    if (err?.graphQLErrors[0]?.code === 415) {
      return <LoginAlert text={err.message} />;
    }
    if (err?.graphQLErrors[0]?.code === 408) {
      err.message = "هذا المستخدم لا يوفر خدماته على منصة عقار حالياً";
    }
    Modal.open(
      <WarningAlert text={err.message} code={err.graphQLErrors[0].code} />,
    )();
  };
  const [getPhoneAsString, { loading: isGetPhoneLoading }] = useLazyQuery(
    GET_PHONE_AS_STRING,
    {
      context: { token },
      onCompleted: () => {
        if (id) {
          incrementListingAction({
            variables: { id, type: "phone_views" },
          });
        }
      },
      onError: handleError,
    },
  );

  const [getWhatsappLink, { loading: getWhatsappLinkLoading }] = useMutation(
    GET_WHATSAPP_LINK,
    {
      context: { token },
      onCompleted: () => {
        if (id) {
          incrementListingAction({
            variables: { id, type: "phone_views" },
          });
        }
      },
      onError: handleError,
    },
  );

  const getWhatsappPhone = async () => {
    const { data } = await getWhatsappLink({
      variables: {
        id,
        whatsapp: true,
      },
    });
    return data?.Listing?.initWhatsappUserBrokerCommunication?.redirect_url;
  };

  const getCallsPhone = async () => {
    const { data } = await getPhoneAsString({
      variables: {
        id,
        whatsapp: false,
      },
    });
    return data?.Listing?.getPhoneAsString;
  };

  return {
    getCallsPhone,
    getWhatsappPhone,
    handleError,
    // will be used one added a spinner component to the button
    loading: isGetPhoneLoading,
  };
};

export default useGetPhone;
